import { useEffect } from 'react';
import { motionDisabled } from '@/shared/lib/motion';

/**
 * "ברק" שעוקב אחרי העכבר על כרטיסים (עיצוב v2: radial-gradient ב-::after
 * לפי --mx/--my, נדלק ב---gl). מאזין אחד על המסמך במקום onMouseMove בכל
 * כרטיס — כל .card במסך מקבל את האפקט, כולל כרטיסים של מסכים עתידיים.
 */
export function useCardGlare() {
  useEffect(() => {
    if (motionDisabled() || !window.matchMedia?.('(hover: hover)').matches) return;
    let current: HTMLElement | null = null;
    let raf = 0;
    let lastEvent: PointerEvent | null = null;

    const apply = () => {
      raf = 0;
      const ev = lastEvent;
      if (!ev) return;
      const card = (ev.target as Element | null)?.closest?.('.card') as HTMLElement | null;
      if (card !== current) {
        current?.style.setProperty('--gl', '0');
        current = card;
      }
      if (!card) return;
      const r = card.getBoundingClientRect();
      card.style.setProperty('--mx', `${ev.clientX - r.left}px`);
      card.style.setProperty('--my', `${ev.clientY - r.top}px`);
      card.style.setProperty('--gl', '1');
    };
    const onMove = (ev: PointerEvent) => {
      if (ev.pointerType !== 'mouse') return;
      lastEvent = ev;
      if (!raf) raf = requestAnimationFrame(apply);
    };
    const onLeave = () => { current?.style.setProperty('--gl', '0'); current = null; };

    document.addEventListener('pointermove', onMove, { passive: true });
    document.documentElement.addEventListener('pointerleave', onLeave);
    return () => {
      document.removeEventListener('pointermove', onMove);
      document.documentElement.removeEventListener('pointerleave', onLeave);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
}
